import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import LoginIllustration from "../../assets/login-illustration.png";
import LoginBackground from "../../assets/login-bg.png";
import * as colors from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { forgotStart } from "../../store/auth/reducer";



export const Forgot = ({ setActive, onClose }) => {
  const dispatch = useDispatch();
  const { forgotLoading, forgotError, token } = useSelector(
    (state) => state.auth
  );
  // console.log("forgot here is forgot page")
  const DEFAULT_VALUES = {
    email: "",
    verificationToken: "",
  };
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: DEFAULT_VALUES,
  });

  //   useEffect(() => {
  //     if (token) {
  //       reset(DEFAULT_VALUES);
  //       onClose();
  //     }
  //   }, [token]);

  const onSubmit = (values) =>

    dispatch(
      forgotStart({
        ...values,
      }),
      setActive("RESET")
    );
  // 
  // }
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: `url(${LoginBackground})`,
          backgroundRepeat: "no-repeat",
          height: "150px",
        }}
      >
        <img
          src={LoginIllustration}
          alt="Login Illustration"
          width="100px"
          height="100px"
        />
      </Box>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            marginTop: "50px",
          }}
        >
          <Typography variant="h4">Forgot Password</Typography>
          {forgotError && <Alert severity="error">{forgotError}</Alert>}

          <Controller
            name="email"
            control={control}
            rules={{
              required: {
                value: true,
                message: "Email is requried",
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Enter Your Email"
                variant="standard"
                sx={{
                  width: "100%",
                }}
              // helperText={errors.email && errors.email.message}
              // error={!!errors.email}
              />
            )}
          />

          <LoadingButton
            color="primary"
            sx={{
              backgroundColor: "#04B2B2",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#04B2B2",
              },
              marginTop: "10px",
            }}
            loading={forgotLoading}
            type="submit"
          >
            Submit
          </LoadingButton>



        </Box>
      </form>
    </Box>
  );
};
